import React from "react"

class ExcludeButton extends React.Component {
  constructor(props) {
    super(props);

  };

  render() {
    return(
      <a key={this.props.table_action.label} className={"btn btn-secondary"} disabled={this.isActionDisabled(this.props.table_action)} onClick={() => this.props.exclude(this.props.checkboxesChecked)}>{this.toTitleCase(I18n.t(this.props.table_action.label))}</a>
    )
  };

  isActionDisabled() {
    if (this.props.checkboxesChecked.length >= 1 && this.props.table_action.enabled == 'multiple') {
      return false;
    } else if (this.props.checkboxesChecked.length == 1 && this.props.table_action.enabled == 'single') {
      return false;
    } else if (this.props.table_action.enabled == true) {
      return false;
    } else {
      return true;
    }
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
  };
};

export default ExcludeButton